// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_iz-0";
export var actionModalContentContainer = "_iz-1";
export var createTagButton = "_iz-2";
export var footerContainer = "_iz-7";
export var fullWidthDivider = "_iz-3";
export var hasCreateTagButton = "_iz-4";
export var noCreateTagButton = "_iz-5";
export var tagsContainer = "_iz-6";
export var tagsModalContentContainer = "_iz-8";